import { Material, Object3D, Texture } from "three";
import { traverseAllMaterials } from "./traverse-all-materials";

const texturePropertyNames = [
    "alphaMap", "aoMap", "bumpMap", "displacementMap", "emissiveMap", "envMap",
    "lightMap", "map", "metalnessMap", "normalMap", "roughnessMap"
];
export const updateOneMaterial = (mat: Material) => {
    for(const name of texturePropertyNames) {
        if(mat[name] && (mat[name] instanceof Texture) && mat[name].image) {
            mat[name].needsUpdate = true;
        }
    }
}


export const updateAllTextures = (root: Object3D) => {
    for(const mat of traverseAllMaterials(root)) {
        updateOneMaterial(mat);
    }
}

export default updateAllTextures;

